import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getUserStreams } from '../../../api/users';

import { logoutUser } from '../../auth/login/LoginSlice';

import { STATUS_CODE } from '../../../constants/statusCode';
import {
  checkAndSetLoading,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { saveUserDataToCache } from '../../../utils/userCache';

export const fetchUserStreams = createAsyncThunk(
  'currentUser/fetchUserStreams',
  async (params, { signal, rejectWithValue, dispatch }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const response = await getUserStreams({
        cancelToken: source.token,
      });

      return response.data;
    } catch (error) {
      if (error.response?.status === STATUS_CODE.NOT_FOUND) {
        dispatch(logoutUser());
      }

      return rejectWithValue(error?.response?.status);
    }
  },
);

export const fetchUserStreamsExtraReducers = builder => {
  builder
    .addCase(fetchUserStreams.pending, (state, action) => {
      checkAndSetLoading(state.userStreamsRequest, action);
    })
    .addCase(fetchUserStreams.fulfilled, (state, action) => {
      onMatchedRequest(state.userStreamsRequest, action, () => {
        state.streams = action.payload;
        const streamsByRoles = {};
        Object.entries(action.payload).map(([stream, roles]) =>
          roles.map(role => {
            if (!streamsByRoles[role]) {
              streamsByRoles[role] = [];
            }
            streamsByRoles[role].push(stream);
            return role;
          }),
        );
        state.streamsByRoles = streamsByRoles;

        // Save to cache with timestamp
        saveUserDataToCache(
          {
            streams: state.streams,
            streamsByRoles: state.streamsByRoles,
          },
          'streams',
        );
      });
    })
    .addCase(fetchUserStreams.rejected, (state, action) => {
      handleRequestRejection(state.userStreamsRequest, action);
    });
};
